<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const router = useRouter();
const { t } = useI18n();

const tabs = [
  { name: 'home', path: '/', icon: '🏠', label: () => t('nav.home') },
  { name: 'rules', path: '/rules', icon: '📖', label: () => t('nav.rules') },
  { name: 'profile', path: '/profile', icon: '👤', label: () => t('nav.profile') },
];

function isActive(tabName: string) {
  if (tabName === 'profile') {
    return ['profile', 'login', 'change-pw'].includes(String(route.name));
  }
  return route.name === tabName;
}
</script>

<template>
  <nav class="bottom-nav">
    <button v-for="tab in tabs" :key="tab.name"
            class="nav-btn" :class="{ active: isActive(tab.name) }"
            @click="router.push(tab.path)">
      <span class="nav-icon">{{ tab.icon }}</span>
      <span class="nav-label">{{ tab.label() }}</span>
    </button>
  </nav>
</template>

<style scoped>
.bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 90;
  display: flex;
  background: var(--card);
  border-top: 1px solid var(--border);
  padding-bottom: env(safe-area-inset-bottom);
}
.nav-btn {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 8px 4px 6px;
  color: var(--text-dim);
  font-size: 11px;
}
.nav-btn.active { color: var(--primary); }
.nav-icon { font-size: 22px; line-height: 1; }
.nav-label { font-weight: 600; }
</style>
